import { TableGlobalFilter } from "./filters";
import { TablePagination } from "./pagination";
import { TableCheckbox } from "./selection";
import { TableHead, TableResponsive, TableBody, ListMobile } from "./table";
export const Components = {
  Pagination: TablePagination,
  Filter: TableGlobalFilter,
  Table: TableResponsive,
  TableHead: TableHead,
  TableBody: TableBody,
  ListMobile: ListMobile,
  TableCheckbox: TableCheckbox
};